import React, { memo, ReactNode } from 'react';
import { Text } from '../Text';
import * as S from './Checkbox.styles';

export type ICheckboxProps = {
  isChecked: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: ReactNode;
  isDisabled?: boolean;
  forSelectorOption?: boolean;
  removeLabelGap?: boolean;
  'data-testid'?: string;
};

export const Checkbox = memo(
  ({
    isChecked,
    isDisabled,
    onChange,
    label,
    forSelectorOption,
    removeLabelGap,
    'data-testid': dataTestId,
  }: ICheckboxProps) => {
    return (
      <S.Container data-testid={dataTestId} removeGap={removeLabelGap} className='safe-to-click'>
        <Text
          kind='body'
          color={isDisabled ? 'gray3' : 'gray1'}
          className='safe-to-click'
        >
          {label}
        </Text>
        <S.CheckMark isVisible={isChecked} className='safe-to-click' />
        {!forSelectorOption && (
          <S.CheckBoxInput
            type='checkbox'
            checked={isChecked}
            onChange={onChange}
            readOnly={!onChange}
            disabled={isDisabled}
          />
        )}
      </S.Container>
    );
  },
);
